import React from 'react';
import { Tooltip } from '@shared/components/Tooltip';
import ActivateIcon from '@/assets/svg/activate.svg';
import DeactivateIcon from '@/assets/svg/deactivate.svg';

export const SubscriptionStatusSwitchIcon: React.FC<{
  isActivating: boolean;
}> = ({ isActivating }) => {
  const Icon = isActivating ? ActivateIcon : DeactivateIcon;
  return <Icon />;
};

export const SubscriptionPlanStatusDescription: React.FC<{
  planName: string;
  isActivating: boolean;
}> = ({ planName, isActivating }) => {
  const shouldTruncate = planName.length > 40;
  const prefix = isActivating
    ? 'Czy na pewno chcesz aktywować plan subskrypcji '
    : 'Czy na pewno chcesz aktywować plan subskrypcji ';

  return (
    <div className="flex flex-col justify-center items-center">
      <span>{prefix}</span>
      {shouldTruncate ? (
        <Tooltip content={planName} align="right">
          <span
            className="inline-block min-w-0 w-[200px] overflow-hidden font-medium text-ellipsis whitespace-nowrap"
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 500,
              verticalAlign: 'baseline',
            }}
          >
            {planName}?
          </span>
        </Tooltip>
      ) : (
        <span
          className="font-medium"
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 500,
          }}
        >
          {planName}?
        </span>
      )}{' '}
    </div>
  );
};
